/** Converts a repeated card's UI identifier back to the original offer identifier. */
export const normalizeOfferId = (value) => {
    if (typeof value !== "string") return value;
    return value.replace(/_v\d+$/, "");
};

/** Resolves a repeated card to its original offer and one-based ranking position. */
export const getDuplicateOfferDetails = (offerId, offers = []) => {
    const offer = offers.find((item) => item?._id === offerId);
    if (!offer || !offerId) return null;

    const originalId = normalizeOfferId(offerId);
    if (offer._is_dplc !== true && originalId === offerId) return null;

    const originalIndex = offers.findIndex((item) => item?._id === originalId && item?._is_dplc !== true);
    return { offerId: originalId, position: originalIndex < 0 ? undefined : originalIndex + 1 };
};

/** Preserves duplicate attribution for all card layouts before API identifiers are normalized. */
export const prepareDuplicateOfferRequest = (url, params, offers) => {
    if (!/^\/?app_rispromo\/(offer_item|get_promo)\/?$/.test(url)) return params;

    const duplicate = getDuplicateOfferDetails(params?.offerId, offers);
    if (!duplicate) return params;

    return {
        ...params,
        offerId: duplicate.offerId,
        isDuplicated: true,
        ...(duplicate.position === undefined ? {} : { positionOffer: duplicate.position }),
    };
};
